export const LBGhoverEffect = {
  transform: "scale(1.06) translateY(-2px)",
  boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
  background:
    "linear-gradient(to right, var(--chakra-colors-blue-50), var(--chakra-colors-blue-100))",
  transition: "all 0.3s ease-in-out",
};

export const DefaultHoverEffect = {
  transform: "scale(1.04) rotate(0.3deg)",
  background: "linear-gradient(135deg, #60a5fa 0%, #2563eb 100%)",
  boxShadow: "0 12px 28px rgba(0, 0, 0, 0.3), 0 0 16px rgba(0, 191, 255, 0.4)",
  color: "#f8fafc",
  transition: "all 0.3s ease-in-out",
};

export const PlainHoverEffect = {
  transform: "scale(1.04) rotate(0.3deg)",
  boxShadow: "0 12px 28px rgba(0, 0, 0, 0.3), 0 0 16px rgba(0, 191, 255, 0.4)",
  transition: "all 0.3s ease-in-out",
};
